import { ReportImportProblemDocument } from '@/api/queries';
import { ReportImportProblemInput } from '@/models/gen/graphql';
import graphApi from '@/api';

const [runReportImportProblem] = graphApi(ReportImportProblemDocument);

const reportImportProblem = async (input: ReportImportProblemInput) => {
  const res = await runReportImportProblem({ input });
  return res?.reportImportProblem;
};

export default reportImportProblem;
